<mat-nav-list class="menu-list">
  <mat-list-item class="parent home">
    <a routerLink="/job" class="home">
      <img src="../../../../assets/images/bna-logo-home-icon.png" height="35">
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Dashboard" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip">
    <a routerLink="/job">
      <mat-icon class="material-icons-outlined" mat-list-icon>work_outline</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Insights" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip">
    <a routerLink="/insight/reports">
      <mat-icon class="material-icons-outlined" mat-list-icon>assessment</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Invoice Automate" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip" *ngIf="invoiceProcessorEnabled">
    <a [href]="invoiceAutomateUrl">
      <mat-icon class="material-icons-outlined" mat-list-icon>receipt</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="KeyAutomate" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip" *ngIf="keyAutomateEnabled">
    <a [href]="keyAutomateUrl">
      <mat-icon class="material-icons-outlined" mat-list-icon>key_outline</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item *ngIf="!hideInspectionManagerIcon" routerLinkActive="active" matTooltip="Inspection Manager"
    matTooltipPosition="right" matTooltipClass="side-menu-tooltip">
    <a routerLink="/inspection-manager">
      <mat-icon class="material-icons-outlined" mat-list-icon>fact_check</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Settings" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip">
    <a routerLink="/settings">
      <mat-icon class="material-icons-outlined" mat-list-icon>settings</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Communications" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip">
    <a routerLink="/communications">
      <mat-icon matBadge="{{displayUnreadEmailNotificationCount()}}" matBadgeColor="warn"
        [matBadgeHidden]="hiddenUnreadEmailCount()" class="material-icons-outlined" mat-list-icon>forum</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Asset’s Register" matTooltipPosition="right"
  matTooltipClass="side-menu-tooltip" *ngIf="isAssetRegisterViewEnabled">
  <a routerLink="/asset">
    <img class="asset-icon" src="assets/images/asset-default-icon.svg" width="30" height="30"/>
    <!-- <mat-icon class="material-icons-outlined" mat-list-icon>web_asset</mat-icon> -->
  </a>
</mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Start Guide" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip" hidden="true">
    <a href="https://help.bricksandagent.com/en/articles/6074382-getting-started-guide-property-managers"
      target="_blank">
      <mat-icon class="material-icons-outlined" mat-list-icon>local_library</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Ask AI Beta" matTooltipPosition="right"
                 matTooltipClass="side-menu-tooltip" *ngIf="isEnabledPowerBiQnA" >
    <a routerLink="/insight/ai-chat">
      <img class="asset-icon" src="assets/images/AI-icon.svg" width="30" height="30"/>
    </a>
  </mat-list-item>
</mat-nav-list>
